// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
// import "core-js/stable"
// import "regenerator-runtime/runtime"
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';

import 'vant/lib/index.css';
import './assets/css/common.css';//公共样式
import 'swiper/dist/css/swiper.css';

import axios from './api/axios.js'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'mint-ui/lib/style.css'
import AMap from 'vue-amap'
import { Loadmore} from 'mint-ui';
import globalApiConfig from '../config/api.config.js'
import VueLazyload from 'vue-lazyload'  //引入懒加载插件

Es6Promise.polyfill();
Vue.prototype.globalApiConfig = globalApiConfig;
Vue.use(Vant);
Vue.use(router);
Vue.use(ElementUI);
Vue.use(VueLazyload)
Vue.component(Loadmore.name, Loadmore);
Vue.prototype.axios = axios;

// window.floatScreen = function (newvalue) {
//   return !newvalue
// };
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(AMap);


/* eslint-disable no-new */

AMap.initAMapApiLoader({
  key: '5297976ac6ee478791d51e56e3f226fb',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType']
});
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js